import React, { useEffect, useState } from "react";
import {
  formatABN,
  formatAccountNumber,
  formatBSBNumber,
  formatedAddress,
  formatMobile,
  formatName,
  formatNumber,
  formatPhone,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import Spin from "../../components/Spin";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import { CardTitle } from "../../components/ui/card";
import {
  API,
  cddCustomerTypeOptions,
  cddOptions,
  get,
  riskProfile,
} from "../../config";
import { useOrganization } from "../../lib/context/OrganisationContext";

const BeneficiaryDetailsPopup = ({
  beneficiaryId,
  // toggleShowModal,
  showView,
  setShowView,
}) => {
  const { organizationData } = useOrganization();
  const [beneficiaryDetail, setBeneficiaryDetail] = useState(null);
  const [beneficiaryLoading, setBeneficiaryLoading] = useState(true);

  const normalizeVerificationData = (data = {}, verificationType = {}) => {
    if (!verificationType?.fields) return data;

    const dateKeys = verificationType.fields
      .filter((f) => f.inputType === "date")
      .map((f) => f.key);

    const normalizedData = { ...data };

    dateKeys.forEach((key) => {
      if (normalizedData[key]) {
        // eslint-disable-next-line no-self-assign
        normalizedData[key] = normalizedData[key];
      }
    });
    return normalizedData;
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await get(
          `${API.BENEFICARY_DETAILS}/` + beneficiaryId,
        );

        data?.data?.kyc &&
          data?.data?.kyc?.verifications?.length > 0 &&
          data?.data?.kyc?.verifications?.map((item) => {
            const normalizedData = normalizeVerificationData(
              item.data,
              item.verification_document_type,
            );
            item.date_verified = item.date_verified ? item.date_verified : null;
            item.verified_by = item?.verified_by ? item?.verified_by : "";
            item.type = item?.verification_document_type_id
              ? item?.verification_document_type_id
              : "";
            item.fields = item.verification_document_type?.fields?.map(
              (field) => ({
                key: field.key,
                label: field.label,
                value: normalizedData?.[field.key] ?? null,
                inputType: field.inputType || "text",
              }),
            );
            return item;
          });
        setBeneficiaryDetail(data.data);
        setBeneficiaryLoading(false);
      } catch (e) {
        return null;
      }
    }
    fetchData();
  }, [beneficiaryId, setBeneficiaryDetail]);

  return (
    <ResponsiveDrawerForm
      description={""}
      title={"Beneficiary Details"}
      handleOpen={() => {}}
      handleClose={() => {}}
      className={"md:w-[65vw]"}
      open={showView}
      buttonClassName={""}
      setOpen={setShowView}
      read={true}
    >
      {beneficiaryLoading ? (
        <Spin full expand={true} />
      ) : (
        <div className="md:p-0 p-4">
          <div className="modal-content">
            <CardTitle className="text-md mb-2">Personal Details</CardTitle>
            <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
              <p>
                <strong>
                  {getModuleNamingBySlug(
                    organizationData?.organizationData,
                    "vendors",
                    "Vendor",
                  )}
                  :
                </strong>{" "}
                {beneficiaryDetail?.vendor
                  ? formatSubcontractorName(beneficiaryDetail?.vendor)
                  : "-"}
              </p>
              <p>
                <strong>First Name:</strong>{" "}
                {beneficiaryDetail?.first_name
                  ? beneficiaryDetail?.first_name
                  : "-"}
              </p>
              <p>
                <strong>Last Name:</strong> {beneficiaryDetail?.last_name}
              </p>
              <p>
                <strong>Email Address:</strong> {beneficiaryDetail?.email}
              </p>
              <p>
                <strong>Phone Number:</strong>{" "}
                {beneficiaryDetail?.phone
                  ? formatPhone(beneficiaryDetail?.phone)
                  : ""}
              </p>
              <p>
                <strong>Mobile Number:</strong>{" "}
                {beneficiaryDetail?.mobile
                  ? formatMobile(beneficiaryDetail?.mobile)
                  : "-"}
              </p>
              <p>
                <strong>Business Name:</strong>{" "}
                {beneficiaryDetail?.business_name
                  ? beneficiaryDetail?.business_name
                  : "-"}
              </p>

              <p>
                <strong>ABN:</strong>{" "}
                {beneficiaryDetail?.abn
                  ? formatABN(beneficiaryDetail?.abn)
                  : "-"}
              </p>
              <p>
                <strong>Licence Number:</strong>{" "}
                {beneficiaryDetail?.license_number
                  ? beneficiaryDetail?.license_number
                  : "-"}
              </p>
              <p>
                <strong>Code:</strong>{" "}
                {beneficiaryDetail?.code ? beneficiaryDetail?.code : "-"}
              </p>

              <p className="flex gap-1">
                <strong className="whitespace-nowrap">Address:</strong>{" "}
                {formatedAddress(
                  beneficiaryDetail?.street,
                  beneficiaryDetail?.suburb?.name,
                  beneficiaryDetail?.state?.name,
                  beneficiaryDetail?.postal_code,
                )}
              </p>
              <p className="flex gap-1">
                <strong className="whitespace-nowrap">Street Address:</strong>{" "}
                {formatedAddress(
                  beneficiaryDetail?.shipping_street,
                  beneficiaryDetail?.shipping_suburb?.name,
                  beneficiaryDetail?.shipping_state?.name,
                  beneficiaryDetail?.shipping_postal_code,
                )}
              </p>
              <p>
                <strong>Contact Type:</strong>{" "}
                {beneficiaryDetail?.contactable_type
                  ? beneficiaryDetail?.contactable_type === "vendor"
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "Vendor",
                      )
                    : beneficiaryDetail?.contactable_type === "contact"
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "Customer",
                        )
                      : ""
                  : ""}
              </p>
              <p>
                <strong>
                  {beneficiaryDetail?.contactable_type
                    ? beneficiaryDetail?.contactable_type === "vendor"
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "vendors",
                          "Vendor",
                        )
                      : beneficiaryDetail?.contactable_type === "contact"
                        ? getModuleNamingBySlug(
                            organizationData?.organizationData,
                            "contacts",
                            "Customer",
                          )
                        : ""
                    : ""}
                  :
                </strong>{" "}
                {beneficiaryDetail?.contactable
                  ? formatSubcontractorName(beneficiaryDetail?.contactable)
                  : "-"}
              </p>
            </div>
          </div>
          {beneficiaryDetail?.account_name && (
            <div className="modal-content mt-4">
              <CardTitle className="text-md mb-2">
                Bank Account Details
              </CardTitle>
              <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                <p>
                  <strong>Bank Name:</strong>{" "}
                  {beneficiaryDetail?.bank
                    ? beneficiaryDetail?.bank?.abbreviation +
                      "-" +
                      beneficiaryDetail?.bank?.name
                    : "-"}
                </p>
                <p>
                  <strong>Bank Account Name:</strong>{" "}
                  {beneficiaryDetail?.account_name
                    ? beneficiaryDetail?.account_name
                    : "-"}
                </p>
                <p>
                  <strong>BSB:</strong>{" "}
                  {beneficiaryDetail?.bsb
                    ? formatBSBNumber(beneficiaryDetail?.bsb)
                    : "-"}
                </p>
                <p>
                  <strong>Account Number:</strong>{" "}
                  {beneficiaryDetail?.account_number
                    ? formatAccountNumber(beneficiaryDetail?.account_number)
                    : "-"}
                </p>
                <p>
                  <strong>Opening Balance:</strong>{" "}
                  {beneficiaryDetail?.opening_balance
                    ? "$" +
                      formatNumber(Number(beneficiaryDetail?.opening_balance))
                    : "$0.00"}
                </p>
              </div>
            </div>
          )}

          {beneficiaryDetail?.kyc && (
            <div className="modal-content mt-4">
              <CardTitle className="text-md mb-2">
                Proof of ID for Beneficiary Verification (KYC)
              </CardTitle>
              <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                <p>
                  <strong>CDD Customer Type:</strong>{" "}
                  {beneficiaryDetail?.kyc?.cdd_customer_type
                    ? cddCustomerTypeOptions?.find(
                        (item) =>
                          item.value ===
                          beneficiaryDetail?.kyc?.cdd_customer_type,
                      )?.label
                    : "-"}
                </p>

                <p>
                  <strong>CDD:</strong>{" "}
                  {beneficiaryDetail?.kyc?.cdd
                    ? cddOptions?.find(
                        (item) => item.value === beneficiaryDetail?.kyc?.cdd,
                      )?.label
                    : "-"}
                </p>
                <p>
                  <strong>Risk Profile:</strong>{" "}
                  {beneficiaryDetail?.kyc?.risk
                    ? riskProfile?.find(
                        (item) => item.value === beneficiaryDetail?.kyc?.risk,
                      )?.label
                    : "-"}
                </p>

                {beneficiaryDetail?.kyc &&
                  beneficiaryDetail?.kyc?.risk_profile_changes
                    ?.compliance_manager_id && (
                    <>
                      <p>
                        <strong>Escalated To:</strong>{" "}
                        {beneficiaryDetail?.kyc?.risk_profile_changes
                          ?.compliance_manager_name
                          ? beneficiaryDetail?.kyc?.risk_profile_changes
                              ?.compliance_manager_name
                          : "-"}
                      </p>

                      <p>
                        <strong>Reason:</strong>{" "}
                        {beneficiaryDetail?.kyc?.risk_profile_changes?.reason
                          ? beneficiaryDetail?.kyc?.risk_profile_changes?.reason
                          : "-"}
                      </p>
                    </>
                  )}
              </div>
              {beneficiaryDetail?.kyc?.verifications?.map(
                (verifyItem, verifyIndex) => (
                  <>
                    {verifyIndex !== 0 && <hr className="my-2" />}
                    <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                      <p>
                        <strong>Verification Method:</strong>{" "}
                        {verifyItem?.method_title
                          ? verifyItem?.method_title
                          : "-"}
                      </p>
                      <p>
                        <strong>Document Id:</strong>{" "}
                        {verifyItem?.verification_document_type?.label
                          ? verifyItem?.verification_document_type?.label
                          : "-"}
                      </p>
                      {verifyItem?.method === 1 && (
                        <p>
                          <strong>Document Number:</strong>{" "}
                          {verifyItem?.document_number
                            ? verifyItem?.document_number
                            : "-"}
                        </p>
                      )}

                      {verifyItem?.method === 3 && (
                        <>
                          {verifyItem?.fields?.length > 0 &&
                            verifyItem?.fields?.map((field) => (
                              <p key={field.key}>
                                <strong>{field.label}:</strong> {field.value}
                              </p>
                            ))}
                        </>
                      )}
                      <p>
                        <strong>Verification Date:</strong>{" "}
                        {verifyItem?.date_verified
                          ? verifyItem?.date_verified
                          : "-"}
                      </p>
                      <p>
                        <strong>Verified By:</strong>{" "}
                        {verifyItem?.verified_by
                          ? formatName(
                              verifyItem?.verified_by?.first_name,
                              verifyItem?.verified_by?.last_name,
                            )
                          : "-"}
                      </p>
                    </div>
                  </>
                ),
              )}
            </div>
          )}
        </div>
      )}
    </ResponsiveDrawerForm>
  );
};

export default BeneficiaryDetailsPopup;
